<script setup lang="ts">
import SearchPage from '@/components/search-page'

defineOptions({
  name: 'SearchView',
})
</script>

<template>
  <SearchPage />
</template>
